import React from 'react';

import { SVGPropsType } from 'src/types';

function ExpandOut(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path d="M9 3H13V7" stroke={stroke} strokeLinejoin="round" />
            <path d="M9 13H13V9" stroke={stroke} strokeLinejoin="round" />
            <path d="M7 3H3V7" stroke={stroke} strokeLinejoin="round" />
            <path d="M7 13H3V9" stroke={stroke} strokeLinejoin="round" />
            <path d="M9 7L13 3" stroke={stroke} />
            <path d="M3 13L7 9" stroke={stroke} />
        </svg>
    );
}

export default ExpandOut;
